export default __webpack_public_path__ + "static/media/imgscan.44b410f1.png";